<template>
  <div>
    <div class="row">
      <div class="col-6 col-md-4">
        <DefaultVideoCard :show_loader="is_loading"></DefaultVideoCard>
      </div>
      <div class="col-6 col-md-4">
        <DefaultVideoCard :show_loader="is_loading"></DefaultVideoCard>
      </div>
      <div class="col-6 col-md-4">
        <DefaultVideoCard :show_loader="is_loading"></DefaultVideoCard>
      </div>
      <div class="col-6 col-md-4">
        <DefaultVideoCard :show_loader="is_loading"></DefaultVideoCard>
      </div>
      <div class="col-6 col-md-4">
        <DefaultVideoCard :show_loader="is_loading"></DefaultVideoCard>
      </div>
      <div class="col-6 col-md-4">
        <DefaultVideoCard :show_loader="is_loading"></DefaultVideoCard>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultVideoCard from "@/components/classComps/library/DefaultVideoCard";

export default {
  name: "DefaultVideoInfo",

  props: {
    is_empty: {
      type: Boolean,
      default: false
    },
    is_loading: {
      type: Boolean,
      default: true
    }
  },

  components: {
    DefaultVideoCard
  }
};
</script>

<style lang="scss">
</style>
